import "./OurHeritage.module.css";
import TheEssenceHeader from "@/reusable_sections/Header";
import TheEssenceStory from "./sections/TheEssenceStory";
import TheArtOfExtraction from "./sections/TheArtOfExtraction";
import JoinTheInnerCircle from "./sections/JoinTheInnerCircle";
import TheBoutiqueFooter from "@/reusable_sections/Footer";
export default function OurHeritagePage() {
  return <div>
      <TheEssenceHeader />
      <TheEssenceStory />
      <TheArtOfExtraction />
      <JoinTheInnerCircle />
      <TheBoutiqueFooter />
    </div>;
}